module.exports = __webpack_public_path__ + "img/clock-logo.792bcf47.svg";